import { FusionError } from "@fusion-advantage/backcompat"
import { shallowEqual } from "../shallowEqual"
import { Appointment, newWorkItemKey, Todo, TodoKey, WorkItemKey, WorkItemType } from "./WorkItem"

export enum DashboardLoadStatus {
	Loading = 'loading',
	Ready = 'ready',
	Error = 'error',
}

export enum DashboardLoadItemStatus {
	Loading = 'loading',  // not currently used (loads from ldb are instant) but the components support it
	Ready = 'ready',
	Error = 'error',
	Cancelled = 'cancelled',
}

export type StatusedTodo = {
	type: WorkItemType.Todo
	status: DashboardLoadItemStatus.Error
	itemKey: TodoKey
	error: FusionError
} | {
	type: WorkItemType.Todo
	status: (
		DashboardLoadItemStatus.Cancelled|
		DashboardLoadItemStatus.Ready
	)
	item: Todo
}

export type StatusedAppointment = {
	type: WorkItemType.Appointment
	status: DashboardLoadItemStatus.Error
	item: Appointment
	error: FusionError
} | {
	type: WorkItemType.Appointment
	status: (
		DashboardLoadItemStatus.Cancelled|
		DashboardLoadItemStatus.Ready
	)
	item: Appointment
	encounterGuid: string
}

export const statusedWorkItemKey = (statusedItem: StatusedTodo|StatusedAppointment): WorkItemKey => {
	if(
		statusedItem.type === WorkItemType.Todo &&
		statusedItem.status === DashboardLoadItemStatus.Error
	) {
		return statusedItem.itemKey
	}
	return newWorkItemKey(statusedItem.item)
}

export enum DashboardSelectionType {
	TodaySummary = 'todaySummary',
	WorkItem = 'workItem',
}

export type DashboardSelection = {
	type: DashboardSelectionType.TodaySummary
} | {
	type: DashboardSelectionType.WorkItem
	key: WorkItemKey
}

export const isDashboardSelectionMatch = (workItemKey: WorkItemKey, selection: DashboardSelection): boolean => {
	if(selection.type === DashboardSelectionType.TodaySummary) {
		return false
	}
	return shallowEqual(workItemKey, selection.key)
}
